import { useStore } from '../context/StoreContext';

export const DEFAULT_TIMEZONE = 'Australia/Melbourne';

export const useStoreTimezone = () => {
  const { activeStore } = useStore();
  return activeStore?.timezone || DEFAULT_TIMEZONE;
};

export default useStoreTimezone;
